export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = 1440;

export const deriveDisplayState = (minutes) => {
  if (minutes === undefined || minutes === null || minutes === "") {
    return { value: "", unit: "minutes" };
  }
  const num = Number(minutes);
  if (num % MINUTES_IN_DAY === 0) {
    return { value: num / MINUTES_IN_DAY, unit: "days" };
  }
  if (num % MINUTES_IN_HOUR === 0) {
    return { value: num / MINUTES_IN_HOUR, unit: "hours" };
  }
  return { value: num, unit: "minutes" };
};

export const toMinutes = (value, unit) => {
  const num = Number(value);
  if (Number.isNaN(num)) return undefined;
  if (unit === "days") return num * MINUTES_IN_DAY;
  if (unit === "hours") return num * MINUTES_IN_HOUR;
  return num;
};
